import { PillTheme } from "@redotech/redo-storefront-common/pill-theme";
import classNames from "classnames";
import { memo } from "react";
import {
  RedoBadge,
  RedoBadgeColor,
  RedoBadgeType,
} from "../arbiter-components/badge/redo-badge";
import XIcon from "../icon-old/x.svg";
import * as conversationTagPillCss from "./conversation-tag-pill.module.css";

interface ConversationTagLike {
  name: string;
  pillTheme: PillTheme;
}

export const ConversationTagPill = memo(function ConversationTagPill({
  tag,
  xClicked,
  showOverflow = false,
}: {
  tag: ConversationTagLike;
  xClicked?(): void;
  showOverflow?: boolean;
}) {
  return (
    <div
      className={classNames(
        conversationTagPillCss.pillWrapper,
        showOverflow && conversationTagPillCss.showOverflow,
      )}
    >
      <RedoBadge
        color={BadgePillThemeToColorMapping[tag.pillTheme]}
        iconTrailing={
          xClicked
            ? { type: "icon", onClick: xClicked, Icon: XIcon }
            : undefined
        }
        size="sm"
        text={tag.name}
        type={BadgePillThemeToTypeMapping[tag.pillTheme]}
      />
    </div>
  );
});

const BadgePillThemeToColorMapping: Record<PillTheme, RedoBadgeColor> = {
  [PillTheme.NORMAL]: "gray",
  [PillTheme.PRIMARY_LIGHT]: "purple",
  [PillTheme.LIGHT_PINK]: "pink",
  [PillTheme.DANGER]: "orange",
  [PillTheme.NEUTRAL_YELLOW]: "warning",
  [PillTheme.SUCCESS]: "success",
  [PillTheme.NEUTRAL_BLUE]: "blueLight",
  [PillTheme.PRIMARY]: "purple",
  [PillTheme.SOLID_PINK]: "pink",
  [PillTheme.SOLID_RED]: "error",
  [PillTheme.SOLID_ORANGE]: "orange",
  [PillTheme.SOLID_YELLOW]: "warning",
  [PillTheme.SOLID_GREEN]: "success",
  [PillTheme.SOLID_LIGHT_BLUE]: "blue",
  [PillTheme.SOLID_NAVY]: "indigo",
  [PillTheme.SOLID_BLACK]: "black",
  [PillTheme.SOLID_WHITE]: "white",
  [PillTheme.BRAND]: "brand",
  [PillTheme.GRAY_BLUE]: "grayBlue",
  [PillTheme.WHITE_SUCCESS]: "whiteSuccess",
  [PillTheme.GRAY_ALTERNATE]: "gray",
  [PillTheme.BRAND_ALTERNATE]: "brand",
  [PillTheme.ERROR_ALTERNATE]: "error",
  [PillTheme.WARNING_ALTERNATE]: "warning",
  [PillTheme.SUCCESS_ALTERNATE]: "success",
  [PillTheme.GRAY_BLUE_ALTERNATE]: "grayBlue",
  [PillTheme.BLUE_LIGHT_ALTERNATE]: "blueLight",
  [PillTheme.BLUE_ALTERNATE]: "blue",
  [PillTheme.INDIGO_ALTERNATE]: "indigo",
  [PillTheme.PURPLE_ALTERNATE]: "purple",
  [PillTheme.PINK_ALTERNATE]: "pink",
  [PillTheme.ORANGE_ALTERNATE]: "orange",
  [PillTheme.BLACK_ALTERNATE]: "black",
  [PillTheme.WHITE_ALTERNATE]: "white",
  [PillTheme.WHITE_SUCCESS_ALTERNATE]: "whiteSuccess",
};

const BadgePillThemeToTypeMapping: Record<PillTheme, RedoBadgeType> = {
  [PillTheme.NORMAL]: "primary",
  [PillTheme.PRIMARY_LIGHT]: "primary",
  [PillTheme.LIGHT_PINK]: "primary",
  [PillTheme.DANGER]: "primary",
  [PillTheme.NEUTRAL_YELLOW]: "primary",
  [PillTheme.SUCCESS]: "primary",
  [PillTheme.NEUTRAL_BLUE]: "primary",
  [PillTheme.PRIMARY]: "primary",
  [PillTheme.SOLID_PINK]: "primary",
  [PillTheme.SOLID_RED]: "primary",
  [PillTheme.SOLID_ORANGE]: "primary",
  [PillTheme.SOLID_YELLOW]: "primary",
  [PillTheme.SOLID_GREEN]: "primary",
  [PillTheme.SOLID_LIGHT_BLUE]: "primary",
  [PillTheme.SOLID_NAVY]: "primary",
  [PillTheme.SOLID_BLACK]: "primary",
  [PillTheme.SOLID_WHITE]: "primary",
  [PillTheme.BRAND]: "primary",
  [PillTheme.GRAY_BLUE]: "primary",
  [PillTheme.WHITE_SUCCESS]: "primary",
  [PillTheme.GRAY_ALTERNATE]: "alternate",
  [PillTheme.BRAND_ALTERNATE]: "alternate",
  [PillTheme.ERROR_ALTERNATE]: "alternate",
  [PillTheme.WARNING_ALTERNATE]: "alternate",
  [PillTheme.SUCCESS_ALTERNATE]: "alternate",
  [PillTheme.GRAY_BLUE_ALTERNATE]: "alternate",
  [PillTheme.BLUE_LIGHT_ALTERNATE]: "alternate",
  [PillTheme.BLUE_ALTERNATE]: "alternate",
  [PillTheme.INDIGO_ALTERNATE]: "alternate",
  [PillTheme.PURPLE_ALTERNATE]: "alternate",
  [PillTheme.PINK_ALTERNATE]: "alternate",
  [PillTheme.ORANGE_ALTERNATE]: "alternate",
  [PillTheme.BLACK_ALTERNATE]: "alternate",
  [PillTheme.WHITE_ALTERNATE]: "alternate",
  [PillTheme.WHITE_SUCCESS_ALTERNATE]: "alternate",
};
